import React, { Fragment } from "react";

import "./AttributeGroup.css";
import NoContent from "../NoContent/NoContent";
import { required, length } from "../../util/validators";
import Input from "../../components/Form/Input/Input";
import Button from "../../components/Button/Button";
import MessageHandler from "../../components/MessageHandler/MessageHandler";

const POST_FORM = {
  title: {
    value: "",
    valid: false,
    touched: false,
    errorMessage: "",
    validators: [required, length({ min: 2 })],
  },
  categoryCode: {
    value: 0,
    valid: true,
    touched: true,
    errorMessage: "",
    validators: [],
  },
};

class AttributeGroup extends React.Component {
  constructor(props) {
    super(props);
    this.scrollAttributeGroup = React.createRef();  

    this.state = {
      postForm: POST_FORM,
      formIsValid: false,
      imagePreview: null,
      attributeGroups: [],
      noAttributeGroup: true,
      noAttributeGroupFormMode: true,
      isEditing: false,
      isEditSection: false,
      activeAttributeGroup: [],
      isItemEditSection: false,
      showMessage: false,
      selectedAttributeGroupCode: 0,
      attributeGroupCode: 0,
      deleteAttributeGroupTitle: "",
    };
  }

  componentDidMount() {
    if (this.props.attributeGroups.length !== 0) {
      this.setState({
        attributeGroups: this.props.attributeGroups,
        noAttributeGroup: false,
        noAttributeGroupFormMode: false,
        activeAttributeGroup: new Array(this.props.attributeGroups.length).fill(
          false
        ),
      });
      //   console.log(this.props.attributeGroups);
    }
    this.smoothScroll(this.scrollAttributeGroup.current);
  }

  smoothScroll(target) {
    const { top } = target.getBoundingClientRect()
    window.scrollTo({
      top: top + window.pageYOffset,
      behavior: "smooth"
    });
  }

  componentDidUpdate(previousProps, previousState) {
    if (previousProps.attributeGroups !== this.props.attributeGroups) {
      let updatedForm = POST_FORM;
        updatedForm["title"].value = "";
        updatedForm["title"].valid = false;
        updatedForm["title"].touched = false;
        updatedForm["title"].errorMessage = "";
        updatedForm["categoryCode"].value = 0;
        updatedForm["categoryCode"].valid = true;
        updatedForm["categoryCode"].touched = true;
        updatedForm["categoryCode"].errorMessage = "";
        

      this.setState({
        attributeGroups: this.props.attributeGroups,
        postForm: updatedForm,
        formIsValid: false,
        noAttributeGroup: false,
        noAttributeGroupFormMode: false,
        activeAttributeGroup: new Array(this.props.attributeGroups.length).fill(
          false
        ),
      });
    }
  }

  postInputChangeHandler = (input, value, files) => {
    this.setState((prevState) => {
      let isValid = true;
      let errorMessage = "";
      for (const validator of prevState.postForm[input].validators) {
        isValid = isValid && validator(value).hasError;
        errorMessage =
          !isValid && errorMessage === "" ? validator(value).errorMessage : errorMessage;
      }
      const updatedForm = {
        ...prevState.postForm,
        [input]: {
          ...prevState.postForm[input],
          valid: isValid,
          errorMessage: errorMessage,
          value: files ? files[0] : value,
        },
      };

      let formIsValid = updatedForm["title"].valid;

      return {
        postForm: updatedForm,
        formIsValid: formIsValid,
      };
    });
  };

  inputBlurHandler = (input) => {
    this.setState((prevState) => {
      return {
        postForm: {
          ...prevState.postForm,
          [input]: {
            ...prevState.postForm[input],
            touched: true,
          },
        },
      };
    });
  };

  acceptPostChangeHandler = () => {
    if (this.state.formIsValid) {
      const post = {
        title: this.state.postForm.title.value,
        code: this.state.attributeGroupCode,
      };
      if (this.state.isEditing) {
        this.props.onEditHandler(post);
      } else {
        this.props.onAcceptModal(post);
      }
      this.setState({
        postForm: POST_FORM,
        formIsValid: false,
        isEditing: false,
        isEditSection: false,
      });
    } else {
      this.setState((prevState) => {
        let updatedForm = { ...prevState.postForm };

        let isValid = true;
        let errorMessage = "";
        for (const validator of prevState.postForm["title"].validators) {
          isValid =
            isValid && validator(prevState.postForm["title"].value).hasError;
          errorMessage =
            !isValid && errorMessage === ""
              ? validator(prevState.postForm["title"].value).errorMessage
              : errorMessage;
        }
        updatedForm = {
          ...updatedForm,
          ["title"]: {
            ...updatedForm["title"],
            valid: isValid,
            errorMessage: errorMessage,
          },
        };

        return {
          postForm: updatedForm,
        };
      });
    }
  };

  newAttributeGroupHandler = () => {
    this.setState({
      noAttributeGroupFormMode: true,
      noAttributeGroup: false,

      postForm: POST_FORM,
      formIsValid: false,
      isEditing: false,
      isEditSection: true,
      isItemEditSection: false,
    });
  };

  toggleClass(index) {
    const previousState = [...this.state.activeAttributeGroup];
    const indexOfTrue = previousState.indexOf(true);
    previousState[indexOfTrue] = false;
    previousState[index] = true;
    this.setState({
      selectedAttributeGroupCode: this.state.attributeGroups[index].code,
      activeAttributeGroup: previousState,
      formIsValid: true,
      isEditing: false,
      isEditSection: false,
      isItemEditSection: true,
    });

    this.props.cancelAttributeHandler();
  }

  toggleAttributeGroupClass = () => {
    this.setState({
      postForm: POST_FORM,
      formIsValid: false,
      isEditing: false,
      isEditSection: true,
      activeAttributeGroup: new Array(this.props.attributeGroups.length).fill(
        false
      ),
      isItemEditSection: false,
    });
    // this.props.onCancelEdit();
  };

  cancelPostChangeHandler = () => {
    this.setState({
      postForm: POST_FORM,
      formIsValid: false,
      isEditing: false,
      isEditSection: false,
      activeAttributeGroup: new Array(this.props.attributeGroups.length).fill(
        false
      ),
      isItemEditSection: false,
    });
    // this.props.onCancelEdit();
  };

  addNewAttributeHandler = () => {
    this.props.newAttributeHandler(this.state.selectedAttributeGroupCode);
  };

  onEditHandler = (data) => {
    const Index = this.state.attributeGroups.findIndex(
      (p) => p.code === data.code
    );
    this.setState(() => {
      const updatedForm = {
        title: {
          value: this.state.attributeGroups[Index].title,
          valid: true,
          touched: true,
          errorMessage: "",
          validators: [required, length({ min: 2 })],
        },
        categoryCode: {
          value: 0,
          valid: true,
          touched: true,
          errorMessage: "",
          validators: [],
        },
      };
      return {
        postForm: updatedForm,
        formIsValid: true,
        attributeGroupCode: data.code,
        isEditSection: true,
        isEditing: true,
      };
    });
  };

  onDeleteHandler = (data) => {
    const Index = this.state.attributeGroups.findIndex(
      (p) => p.code === data.code
    );

    this.setState({
      attributeGroupCode: data.code,
      showMessage: true,
      deleteAttributeGroupTitle: this.state.attributeGroups[Index].title,
    });
  };

  onDeleteAttributeGroupHandler = () => {
    this.props.onDeleteHandler({
      code: this.state.attributeGroupCode,
    });
    this.setState({
      attributeGroupCode: 0,
      showMessage: false,
      deleteAttributeGroupTitle: "",
    });
  };

  onCancelAttributeGroupHandler = () => {
    this.setState({
      attributeGroupCode: 0,
      showMessage: false,
      deleteAttributeGroupTitle: "",
    });
  };

  render() {
    return (
      <div ref={this.scrollAttributeGroup}>
        <MessageHandler
          showMessage={this.state.showMessage}
          onHandle={this.onCancelAttributeGroupHandler}
          message={
            'آیا می‌خواهید گروه ویژگی "' +
            this.state.deleteAttributeGroupTitle +
            '" را پاک کنید؟'
          }
          onCancelModal={this.onCancelAttributeGroupHandler}
          onAcceptModal={this.onDeleteAttributeGroupHandler}
          acceptMessage="تایید"
          cancelMessage="لغو"
        />
        {this.state.noAttributeGroup && (
          <NoContent
            firstInfoStatement="شما تا به حال هیچ گروه ویژگی‌ تعریف نکرده‌اید"
            secondInfoStatement="برای درج ویژگی‌های کالایی میبایست ابتدا گروه ویژگی‌های کالایی را تعریف کنید."
            image="https://seller.digikala.com/static/files/ac21f0e6.svg"
            onClickHandler={this.newAttributeGroupHandler}
            button="افزودن گروه ویژگی‌های کالایی"
          />
        )}
        {!this.state.noAttributeGroup && (
          <div className="uk-position-relative">
            <div className="mn-grid__row">
              <div className="mn-attribute-group-select">
                <div className="mn-attribute-group-select__section">
                  {this.state.noAttributeGroupFormMode && (
                    <div className="mn-attribute-group-select__section-empty">
                      {"گروه ویژگی‌ تعریف نشده است"}
                    </div>
                  )}
                  {!this.state.noAttributeGroupFormMode && (
                    <div className="mn-attribute-group-select__section-fields">
                      <ul>
                        {this.props.attributeGroups.map((data, index) => {
                          return (
                            <li key={index} className="mn-attribute-group-li">
                              <label
                                htmlFor={index}
                                className={[
                                  "mn-attribute-group-select__item mn-attribute-group-select__link",
                                  this.state.activeAttributeGroup[index]
                                    ? "is-active"
                                    : "",
                                ].join(" ")}
                                onClick={() => {
                                  this.toggleClass(index);
                                  // this.props.onSelect(category);
                                }}
                              >
                                <input
                                  type="radio"
                                  className="uk-hidden js-category-data"
                                  data-id={index}
                                  value={data.title}
                                />
                                {data.title}
                              </label>
                              <span className="mn-attribute-group__spacer"></span>
                              <span className="mn-attribute-group-select__item_icon">
                                <i
                                  className="fa fa-pencil-square-o mn-attribute-group-select__item-edit"
                                  aria-hidden="true"
                                  onClick={this.onEditHandler.bind(this, {
                                    code: data.code,
                                  })}
                                ></i>
                                <i
                                  className="fa fa-trash-o mn-attribute-group-select__item-delete"
                                  aria-hidden="true"
                                  onClick={this.onDeleteHandler.bind(this, {
                                    code: data.code,
                                  })}
                                ></i>
                              </span>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
              <div className="mn-attribute-group-edit">
                <div className="mn-attribute-group-edit__section">
                  <div className="mn-grid__row mn-grid__row-space">
                    <div className="mn-grid__col mn-grid__col--sm-6 mn-grid__col--lg-10 mn-RD-profile__section-title">
                      <span className="mn-RD-profile__title">
                        {"ایجاد گروه ویژگی کالایی"}
                      </span>
                    </div>
                    <div
                      className={[
                        "mn-grid__col mn-grid__col--sm-6 mn-grid__col--lg-2",
                        `${this.state.isEditSection && "uk-hidden"}`,
                      ].join(" ")}
                    >
                      <Button
                        design="next"
                        mode=""
                        type="submit"
                        loading={false}
                        onClick={this.toggleAttributeGroupClass}
                      >
                        {"افزودن گروه ویژگی"}
                      </Button>
                    </div>
                  </div>

                  {this.state.isEditSection && (
                    <div className="mn-RD-profile__add-doc uk-width-1-1">
                      <span className="uk-width-1-1 uk-text-right mn-attribute-group__edit-title">
                        بارگذاری اطلاعات جدید
                      </span>
                      <form onSubmit={e => { e.preventDefault(); }}>
                        <div className="mn-attribute-group__input mn-grid__col mn-grid__col--gap-lg mn-grid__col--row-attr mn-grid__col--flex-initial mn-grid__col--sm-6">
                          <Input
                            id="title"
                            label={"عنوان گروه ویژگی"}
                            type="text"
                            control="input"
                            required="required"
                            onChange={this.postInputChangeHandler}
                            onBlur={this.inputBlurHandler.bind(this, "title")}
                            valid={this.state.postForm["title"].valid}
                            touched={this.state.postForm["title"].touched}
                            value={this.state.postForm["title"].value}
                            validationError={
                              !this.state.valid &&
                              this.state.postForm["title"].errorMessage
                            }
                          />
                        </div>
                      </form>
                      <div className="uk-flex uk-flex-right uk-flex-bottom">
                        <Button
                          design="next"
                          mode=""
                          type="submit"
                          loading={false}
                          onClick={this.acceptPostChangeHandler}
                        >
                          {this.state.isEditing
                            ? "ویرایش گروه ویژگی"
                            : "ثبت گروه ویژگی"}
                        </Button>
                        <Button
                          design="reset"
                          mode=""
                          type="submit"
                          loading={false}
                          onClick={this.cancelPostChangeHandler}
                        >
                          {}
                        </Button>
                      </div>
                    </div>
                  )}
                  {!this.state.isEditSection && (
                    <Fragment>
                      {!this.state.isItemEditSection && (
                        <NoContent
                          firstInfoStatement="برای درج ویژگی ابتدا یک گروه ویژگی را تعریف کنید."
                          secondInfoStatement="برای ویرایش ویژگی‌ کالایی میبایست ابتدا یک گروه ویژگی‌ را انتخاب کنید."
                          image=""
                          onClickHandler={this.newAttributeGroupHandler}
                          empty={true}
                          button=""
                        />
                      )}
                      {this.state.isItemEditSection && (
                        <NoContent
                          firstInfoStatement="برای درج ویژگی ابتدا یک گروه ویژگی را تعریف کنید."
                          secondInfoStatement="برای ویرایش ویژگی‌ کالایی میبایست ابتدا یک گروه ویژگی‌ را انتخاب کنید."
                          image=""
                          onClickHandler={this.addNewAttributeHandler}
                          empty={true}
                          button="افزودن ویژگی‌های کالایی"
                        />
                      )}
                    </Fragment>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}


export default AttributeGroup;